import { setStorage, getStorage } from '@/utils/storage'

const state = {
  inElectron: true,
  size: getStorage('smartTeachingFontSize') || 32,
  zoom: getStorage('smartTeachingFontZoom') || 1,
  // measureRateScale: {} // 评测松紧度
  measureRateScale: { 1: '1.00', 2: '1.00', 3: '1.00', 12: '1.00', 15: '1.15' }, // 评测松紧度
  evaluateLooseness: null, // 评测松紧度typeThres配置（按年级+评测类型映射）
  // 班级答题器版本 UID_t
  classDeviceType: getStorage('classDeviceType') || '18',
  bookMaterial: {}, // 教材版本
  showExportProgress: false, // 右上角导出进度列表
  showBrushVisible: false, // 是否显示画笔
  receiverInfo: {}, // 接收器信息
  hasPromptedUpdate: false, // 本次会话是否已提示过安装更新
  // keep-alive 缓存白名单：存储需要缓存的组件 name（对应路由 meta.keepAlive: true 的页面）
  cachedViews: []
}

const mutations = {
  SET_SIZE: (state, size) => {
    state.size = size
    setStorage('smartTeachingFontSize', size)
  },
  SET_ZOOM: (state, zoom) => {
    state.zoom = zoom
    setStorage('smartTeachingFontZoom', zoom)
  },
  SET_IN_ELECTRON: (state, inElectron) => {
    state.inElectron = inElectron
  },
  SET_MEASURE_RATE_SCALE: (state, measureRateScale) => {
    state.measureRateScale = measureRateScale
  },
  SET_EVALUATE_LOOSENESS: (state, evaluateLooseness) => {
    state.evaluateLooseness = evaluateLooseness
  },
  SET_BOOK_MATERIAL: (state, bookMaterial) => {
    state.bookMaterial = bookMaterial
  },
  SET_SHOW_EXPORT_PROGRESS: (state, bol) => {
    state.showExportProgress = bol
  },
  SET_CLASS_DEVICE_TYPE: (state, uidType) => {
    state.classDeviceType = String(uidType)
    setStorage('classDeviceType', String(uidType))
  },
  SET_SHOW_BRUSH_VISIBLE(state, visible) {
    state.showBrushVisible = visible
  },
  SET_RECEIVER_INFO(state, payload) {
    state.receiverInfo = payload
  },
  SET_HAS_PROMPTED_UPDATE(state, value) {
    state.hasPromptedUpdate = value
  },
  /**
   * 将组件 name 加入 keep-alive 白名单（幂等，已存在则跳过）
   * @param {string} name 组件 name，需与 vue 文件 name 选项一致
   */
  ADD_CACHED_VIEW(state, name) {
    if (!state.cachedViews.includes(name)) {
      state.cachedViews.push(name)
    }
  },
  /**
   * 将组件 name 从 keep-alive 白名单移除，触发组件实例销毁
   * @param {string} name 组件 name
   */
  REMOVE_CACHED_VIEW(state, name) {
    const index = state.cachedViews.indexOf(name)
    if (index !== -1) {
      state.cachedViews.splice(index, 1)
    }
  }
}

const actions = {
  setSize({ commit }, size) {
    commit('SET_SIZE', size)
  },
  setZoom({ commit }, zoom) {
    commit('SET_ZOOM', zoom)
  },
  // 设置当前是否处于 Electron 内
  setInElectron({ commit }, inElectron) {
    commit('SET_IN_ELECTRON', inElectron)
  },
  /**
   * 设置评测的松紧度
   * @param commit
   * @param measureRateScale
   */
  setMeasureRateScale({ commit }, measureRateScale) {
    commit('SET_MEASURE_RATE_SCALE', measureRateScale)
  },
  /**
   * 设置评测松紧度typeThres配置
   * @param commit
   * @param evaluateLooseness
   */
  setEvaluateLooseness({ commit }, evaluateLooseness) {
    commit('SET_EVALUATE_LOOSENESS', evaluateLooseness)
  },
  // 设置教材版本
  setBookMaterial({ commit }, bookMaterial) {
    commit('SET_BOOK_MATERIAL', bookMaterial)
  },
  setShowExportProgress({ commit }, bol) {
    commit('SET_SHOW_EXPORT_PROGRESS', bol)
  },
  setClassDeviceType({ commit }, uidType) {
    commit('SET_CLASS_DEVICE_TYPE', uidType)
  },
  setShowBrushVisible({ commit }, visible) {
    commit('SET_SHOW_BRUSH_VISIBLE', visible)
  },
  setReceiverInfo({ commit }, receiverInfo) {
    commit('SET_RECEIVER_INFO', receiverInfo)
  },
  // 加入 keep-alive 白名单
  addCachedView({ commit }, name) {
    commit('ADD_CACHED_VIEW', name)
  },
  // 从 keep-alive 白名单移除
  removeCachedView({ commit }, name) {
    commit('REMOVE_CACHED_VIEW', name)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
